import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  HostListener,
  Renderer2,
  RendererFactory2
} from '@angular/core';
import { Router } from '@angular/router';
import moment from "moment";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { DeptCategoryPickerComponent } from '../dept-category-picker/dept-category-picker.component';

@Component({
  selector: 'app-date-range-picker-popover',
  templateUrl: './date-range-picker-popover.component.pug',
  styleUrls: ['./date-range-picker-popover.component.scss'],
  standalone: false
})
export class DateRangePickerPopoverComponent implements OnInit, OnChanges {
  @Input() start!: any;
  @Input() end!: any;
  @Input() filterBy = 'Requested date';
  @Input() selectedTab;
  @Input() filterByVar = 'Requested date'
  @Input() filter = $localize`Custom`;
  @Input() hideButtons = false;
  @Input() filterByOptions = [{'key': 'Requested date', 'value': $localize`Requested date`}, {'key': 'Employment end date', 'value': $localize`Employment end date`}];
  @Input() filterByDefaults: any;
  popup = false;
  @Input() departmentId = 'all';
  @Input() departmentCategoryId = 'all';
  @Input() peopleTab = false;
  @Input() selectedCheckboxFilters: any;
  @Input() selectedStatusFilters: any;
  @Input() filterCount: any;
  @Output() filterChange = new EventEmitter();
  @Output() resetFilterChange = new EventEmitter();
  @Output() hide = new EventEmitter();
  filterByLabel = '';
  startDate: Date = new Date();
  endDate: Date = new Date();
  today: Date = new Date();
  enableCustom = false;
  startDatePickerVisible = false;
  endDatePickerVisible = false;
  config = {showWeekNumbers: false };
  @Input() horizontal = false;

  showStartCalendar = false;
  showEndCalendar = false;

  @ViewChild('customDateFilter', {static: false}) customDateFilter: any;
  @ViewChild('filterByFilter', {static: false}) filterByFilter:any
  @ViewChild(DeptCategoryPickerComponent) deptCategoryPicker:any;
  customCheck = $localize`Custom`;
  startStr = '';
  endStr = '';

  localizedData = [
    {key:'All',value:$localize`All`},
    {key:'Send date',value:$localize`Send date`},
    {key:'Cutoff date',value:$localize`Cutoff date`},
    {key:'Last activity',value:$localize`Last activity`},
    {key:'Date added',value:$localize`Date added`},
    {key:'Employment end date',value:$localize`Employment end date`},
    {key:'Requested date',value:$localize`Requested date`},
    {key:'Custom',value:$localize`Custom`},
    {key:'Last 7 days',value:$localize`Last 7 days`},
    {key:'Last 30 days',value:$localize`Last 30 days`},
    {key:'Last 60 days',value:$localize`Last 60 days`},
    {key:'Last 90 days',value:$localize`Last 90 days`},
    {key:'Last 365 days',value:$localize`Last 365 days`},
    {key:'Current week',value:$localize`Current week`},
    {key:'Last week',value:$localize`Last week`},
    {key:'Current month',value:$localize`Current month`},
    {key:'Last month',value:$localize`Last month`},
    {key:'Current quarter',value:$localize`Current quarter`},
    {key:'Last quarter',value:$localize`Last quarter`},
    {key:'Current year',value:$localize`Current year`},
    {key:'Last year',value:$localize`Last year`},
  ]

  // Feature flags
  renderer: Renderer2;

@HostListener('document:click', ['$event'])
clickout(event: any): void {
  const isInsideElement = (id: string): boolean =>
  event.target.id === id || (event.path && event.path[1].id === id);

  const insideRangeDropDownClick = isInsideElement('rangeDropDown');
  if (!insideRangeDropDownClick) {
    this.customDateFilter.hide();
  }
  else {
    setTimeout(() => {
      const popovers = document.querySelectorAll('.popover');
      let targetPopover = Array.from(popovers).find((popover: Element) => {
        return popover.contains(this.customDateFilter.nativeElement);
      });
      if (!targetPopover &&  popovers.length>1){
        targetPopover = popovers[1]
      }
      if (targetPopover) {
        this.renderer.setStyle(targetPopover, 'border-radius', '4px');
        const popoverBody = targetPopover.querySelector('.popover-body');
        if (popoverBody) {
          this.renderer.setStyle(popoverBody, 'border-radius', '4px');
        }
      }
    }, 0);
  }

  const insideFilterTypeDropDown = isInsideElement('filterTypeDropDown');
  if (!insideFilterTypeDropDown) {
    this.filterByFilter.hide();
  }
  else {
    setTimeout(() => {
      const popovers = document.querySelectorAll('.popover');
      let targetPopover = Array.from(popovers).find((popover: Element) => {
        return popover.contains(this.filterByFilter.nativeElement);
      });
      if (!targetPopover &&  popovers.length>1){
        targetPopover = popovers[1]
      }
      if (targetPopover) {
        this.renderer.setStyle(targetPopover, 'border-radius', '4px');
        const popoverBody = targetPopover.querySelector('.popover-body');
        if (popoverBody) {
          this.renderer.setStyle(popoverBody, 'border-radius', '4px');
        }
      }
    }, 0);
  }
}

  constructor(
    private router: Router,
    private permissions: PermissionsService,
    private rendererFactory: RendererFactory2,
  )
  {
    this.renderer = rendererFactory.createRenderer(null, null);
  }


  private setLabel() {
    if(this.filterBy == "Employment end date") {
      this.startStr = this.start.format('MMM, YYYY');
      this.endStr = this.end.format('MMM, YYYY');
    } else {
      this.startStr = this.start.format('DD MMM, YYYY');
      this.endStr = this.end.format('DD MMM, YYYY');
    }
  }

  ngOnInit(): void {
    this.config['dateInputFormat'] = moment.localeData().longDateFormat('L');
    if (this.filter === $localize`All` || this.filter  === 'All') {
      this.start = moment('1970-01-01T00:00:00.000');
      this.end = moment();
    }
    else {
      if (this.filter === $localize`Custom`)
        this.enableCustom = true;
    }

    if (!this.filterBy && this.filterByDefaults) {
      this.filterBy = this.filterByDefaults[0].key;
    }
    for(let filterByOption of this.filterByOptions) {
      if(filterByOption['key'] === this.filterBy) {
        this.filterByLabel = filterByOption['value'];
        break;
      }
    }
    this.setLabel();

    this.filter = this.getLocalizedData(this.filter) || this.filter
    this.filterByVar = this.getLocalizedData(this.filterByVar) || this.filterByVar

  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  showCalendar(type) {
    if (type === 'start') {
      if(this.showStartCalendar) {
        this.showStartCalendar = false;
      } else {
        this.showEndCalendar = false;
        this.showStartCalendar = true;
      }
    } else if (type === 'end') {
      if(this.showEndCalendar) {
        this.showEndCalendar = false;
      } else {
        this.showStartCalendar = false;
        this.showEndCalendar = true;
      }
    }
  }

  cancel() {
    this.hide.emit({});
  }

  apply() {
    this.filterChange.emit({
      'start': this.start,
      'end': this.end,
      'filterBy': this.filterBy,
      'filter': this.getOriginalData(this.filter),
      'department_id': this.departmentId,
      'department_category_id': this.departmentCategoryId,
      'filterByVar': this.getOriginalData(this.filterByVar),
    });
    this.hide.emit({});
  }

  deparmentData(event) {
    this.departmentId = event['department_id'];
    this.departmentCategoryId = event['department_category_id'];
  }

  reset() {
    // TODO does this need to be translated?
    if(this.router.url.includes('people')){
      this.filterBy = 'Last activity';
      this.filterByLabel = 'Last activity';
      this.filterByVar = $localize`Last activity`;
      this.departmentId = 'all';
      this.departmentCategoryId = 'all';
      this.deptCategoryPicker.reset();
      this.all();
      this.resetFilterChange.emit();
    }
    else{
      this.filterBy = 'Requested date';
      this.filterByLabel = 'Requested date';
      this.all();
      this.resetFilterChange.emit();
      this.resetFilter();
    }
  }
  resetFilter(){
    if(this.selectedTab === "pulse") {
      this.filterByVar = this.getLocalizedData('Cutoff date')
    } else if(this.selectedTab === "exit"){
      this.filterByVar = this.getLocalizedData('Send date')
    }
  }
  customMode() {
    this.enableCustom = true;
    this.filter = $localize`Custom`;
    this.start = moment('2023-01-01T00:00:00.000')
    this.end = moment()

    if(this.customDateFilter) {
      this.customDateFilter.hide();
    }
  }

  filterByChange(option) {
    this.filterBy = option['key'];
    this.filterByVar = option['value'];
    this.filterByLabel = option['value'];

    if(this.filterBy === 'Employment end date') {
      this.config['minMode'] = 'month';
      this.config['monthLabel'] = 'MMM';
    } else {
      delete this.config['minMode']
      delete this.config['monthLabel']
    }

    if(this.filterByFilter) {
      this.filterByFilter.hide();
    }
  }

  all() {
    this.enableCustom = false;
    this.filter = $localize`All`;
    this.start = moment('1970-01-01T00:00:00.000');
    this.end = moment();
    this.setLabel()
    if(this.customDateFilter) {
      this.customDateFilter.hide();
    }
  }

  calculateLastDays(filter: string, days: number) {
    this.enableCustom = false;
    this.filter = this.getLocalizedData(filter)
    this.start = moment().startOf('day').subtract(days, 'days');
    this.end = moment();
    this.setLabel()
    if(this.customDateFilter) {
      this.customDateFilter.hide();
    }
  }

  calculateCalendarDates(filter: string) {
    this.enableCustom = false;
    switch(filter) {
      case 'Current week':
        this.start = moment().startOf('week');
        this.end = moment().endOf('week');
        break;
      case 'Last week':
        this.start = moment().subtract(1, 'weeks').startOf('week');
        this.end = moment().subtract(1, 'weeks').endOf('week');
        break;
      case 'Current month':
        this.start = moment().startOf('month');
        this.end = moment().endOf('month');
        break;
      case 'Last month':
        this.start = moment().subtract(1, 'months').startOf('month');
        this.end = moment().subtract(1, 'months').endOf('month');
        break;
      case 'Current quarter':
        this.start = moment().startOf('quarter');
        this.end = moment().endOf('quarter');
        break;
      case 'Last quarter':
        this.start = moment().subtract(1, 'quarters').startOf('quarter');
        this.end = moment().subtract(1, 'quarters').endOf('quarter');
        break;
      case 'Current year':
        this.start = moment().startOf('year');
        this.end = moment().endOf('year');
        break;
      case 'Last year':
        this.start = moment().subtract(1, 'years').startOf('year');
        this.end = moment().subtract(1, 'years').endOf('year');
        break;
    }

    this.filter = this.getLocalizedData(filter)
    this.setLabel()
    if(this.customDateFilter) {
      this.customDateFilter.hide();
    }
  }

  startDateChange(event) {
    const startDate = moment(event)
    this.start = startDate;

    if (this.start > this.end){
      if(this.filterBy == "Employment end date") {
        const endDate = moment(event).endOf('month')
        this.end = endDate;
      } else {
        this.end = startDate;
      }
    }
    this.showStartCalendar = false;
    this.setLabel();
  }

  endDateChange(event: Date) {
    if(this.filterBy == "Employment end date") {
      const endDate = moment(event).endOf('month')
      this.end = endDate;
      if (this.start > this.end){
        const startDate = moment(event).startOf('month')
        this.start = startDate
      }
    } else {
      const endDate = moment(event).endOf('day')
      this.end = endDate;
      if (this.start > this.end){
        this.start = endDate
      }
    }
    this.showEndCalendar = false;
    this.setLabel();
  }

  getLocalizedData(key:string):string {
    const data = this.localizedData.find(item => item.key === key);
    return data ? data.value : '';
  }

  getOriginalData(value:string):string {
    const data = this.localizedData.find(item => item.value === value);
    return data ? data.key : '';
  }

  disableApply() {
    if (this.isDatePickerVisible() || this.areFiltersDefault()) {
      return true;
    }
    return false;
  }

  isDatePickerVisible(): boolean {
    return this.startDatePickerVisible || this.endDatePickerVisible;
  }

  areFiltersDefault(): boolean {
    const filterIsAll = this.getOriginalData(this.filter) === "All";
    const isDefaultfilterByVar = this.isfilterByVarDefault()
    const checkboxFiltersEmptyOrFalse = Object.keys(this.selectedCheckboxFilters).length === 0 || Object.values(this.selectedCheckboxFilters).every(value => !value);
    const statusFiltersEmptyOrFalse = Object.keys(this.selectedStatusFilters).length === 0 || Object.values(this.selectedStatusFilters).every(value => !value);
    const departmentIdIsallOrundefined = this.departmentId === "all" || this.departmentId == undefined
    const departmentCategoryIdIsallOrundefined = this.departmentCategoryId === "all" || this.departmentCategoryId == undefined

    return filterIsAll && isDefaultfilterByVar && checkboxFiltersEmptyOrFalse && statusFiltersEmptyOrFalse && this.filterCount === 0 && departmentIdIsallOrundefined && departmentCategoryIdIsallOrundefined;
  }

  isfilterByVarDefault(): boolean {
    if (this.peopleTab) {
      return this.getOriginalData(this.filterByVar) === "Last activity";
    } else {
      return ["Send date", "Cutoff date"].includes(this.getOriginalData(this.filterByVar))
    }
  }

}
